import { CustomTextFieldNoForm } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { Button, Grid, Typography } from "@mui/material"
import { Visibility } from "@mui/icons-material";
import { useState } from "react";
import { gridSizeMdLg12, gridSizeMdLg6 } from "@/shared";
import { IDataPreventa, IPaymentMethod, PaymentMethodEnum } from "@/shared/interfaces";
import { IPaymentMethodV2, TipoPagoV2Enum } from "@/shared/interfaces/erp/system-settings";
import ImagesWithZoom from "@/shared/components/ui/Images/ImagesWithZoom";

type InfoFormaPagoProps = {
  preventa_data: IDataPreventa;
  forma_pago_data: IPaymentMethod;
  forma_pago_v2_data?: IPaymentMethodV2 | null; // V2: datos a nivel raíz del response
}
export default function InfoFormaPago({ preventa_data, forma_pago_data, forma_pago_v2_data }: InfoFormaPagoProps) {

  const [open, setOpen] = useState(false);

  // V2: Determinar si usar tipo_pago_v2 o forma_pago_data
  const usarV2 = !!preventa_data?.tipo_pago_v2;
  const esDebito = usarV2
    ? preventa_data.tipo_pago_v2 === TipoPagoV2Enum.DEBITO
    : forma_pago_data?.forma_pago === PaymentMethodEnum.DEBITO;
  const esCredito = usarV2
    ? preventa_data.tipo_pago_v2 === TipoPagoV2Enum.CREDITO
    : forma_pago_data?.forma_pago === PaymentMethodEnum.TARJETA;

  // Nombre de la forma de pago a mostrar (prioriza prop, luego preventa_data, luego código)
  const nombreFormaPago = usarV2
    ? forma_pago_v2_data?.nombre ?? preventa_data.forma_pago_v2_data?.nombre ?? preventa_data.forma_pago_v2 ?? ''
    : forma_pago_data?.alias ?? '';

  return (
    <>
      <Button
        color="primary"
        endIcon={<Visibility />}
        onClick={() => {
          setOpen(true)
        }}
      >
        Ver
      </Button>
      {
        open && (
          <ScrollableDialogProps
            onCloseIcon={() => setOpen(false)}
            open={open}
            title="Forma de Pago"
            minWidth="48%"
            contentNode={
              <Grid container spacing={3}>
                {/* V2: Mostrar Tipo de Pago */}
                {usarV2 && (
                  <CustomTextFieldNoForm
                    disabled={true}
                    label="Tipo de Pago"
                    defaultValue={preventa_data.tipo_pago_v2 ?? ''}
                    size={gridSizeMdLg6}
                  />
                )}

                <CustomTextFieldNoForm
                  disabled={true}
                  label="Forma de Pago"
                  defaultValue={nombreFormaPago}
                  size={usarV2 ? gridSizeMdLg6 : gridSizeMdLg12}
                />

                {/* Campos para DÉBITO */}
                {esDebito && (
                  <>
                    <CustomTextFieldNoForm
                      disabled={true}
                      label="Tipo Cuenta Bancaria"
                      defaultValue={preventa_data.tipo_cuenta_bancaria ?? ''}
                      size={gridSizeMdLg6}
                    />

                    <CustomTextFieldNoForm
                      disabled={true}
                      label="Número Cuenta"
                      defaultValue={preventa_data.numero_cuenta ?? ''}
                      size={gridSizeMdLg6}
                    />

                    {preventa_data?.url_foto_cuenta_bancaria && (
                      <Grid item {...gridSizeMdLg12}>
                        <Typography variant='subtitle2' style={{ margin: '0px 0px 20px 0px' }}>
                          Foto Cuenta Bancaria
                        </Typography>
                        <div style={{ textAlign: 'center' }}>
                          <ImagesWithZoom
                            src={`${preventa_data?.url_foto_cuenta_bancaria!}?v=${new Date().getTime()}`}
                            alt="Foto Cuenta Bancaria"
                          />
                        </div>
                      </Grid>
                    )}
                  </>
                )}

                {/* Campos para CRÉDITO/TARJETA */}
                {esCredito && (
                  <>
                    <CustomTextFieldNoForm
                      disabled={true}
                      label="Número Tarjeta"
                      defaultValue={preventa_data.numero_tarjeta ?? ''}
                      size={gridSizeMdLg6}
                    />

                    {preventa_data?.url_foto_tarjeta && (
                      <Grid item {...gridSizeMdLg6}>
                        <Typography variant='subtitle2' style={{ margin: '0px 0px 20px 0px' }}>
                          Foto Tarjeta
                        </Typography>
                        <div style={{ textAlign: 'center' }}>
                          <img
                            src={preventa_data?.url_foto_tarjeta!}
                            style={{
                              height: '150px',
                            }}
                          >
                          </img>
                        </div>
                      </Grid>
                    )}
                  </>
                )}

              </Grid>
            }
          />
        )
      }
    </>
  )
}
